import type { AnchorHTMLAttributes, FC, MouseEvent, ReactNode } from 'react'

import Link from 'next/link'
import { usePageTransition } from '@/components/generals/page-transition'

interface TransitionLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
    href: string
    children: ReactNode
}

/**
 * An internal link that travels through the page curtain. Modified clicks
 * (new tab, new window) fall back to the browser as usual.
 */
export const TransitionLink: FC<TransitionLinkProps> = ({ href, onClick, children, ...rest }): ReactNode => {
    const { navigate } = usePageTransition()

    const handleClick = (event: MouseEvent<HTMLAnchorElement>): void => {
        onClick?.(event)
        if (event.defaultPrevented) return
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

        event.preventDefault()
        navigate(href)
    }

    return (
        <Link href={href} scroll={false} onClick={handleClick} {...rest}>
            {children}
        </Link>
    )
}
